import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import RideBookingsDetailScreen from './screens/RideBookingsDetailScreen';
import RideBookingsListScreen from './screens/RideBookingsListScreen';

function RideBookings() {
  return (
    <KT01BaseLayout isFullScreen>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<RideBookingsListScreen />} />
          <Route path=":bookingId" element={<RideBookingsDetailScreen />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default RideBookings;
